import React from 'react';

const FacebookPageEmbed = () => {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  };

  const iframeHTML = `
    <iframe 
      src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61569572901195&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
      width="340" 
      height="700" 
      style="border:none;overflow:hidden" 
      scrolling="no" 
      frameborder="0" 
      allowfullscreen="true" 
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
    </iframe>
  `;

  return (
    <div style={containerStyle} dangerouslySetInnerHTML={{ __html: iframeHTML }} />
  );
};

export default FacebookPageEmbed;
